var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSopranoSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 26 41.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{stroke:#442c5c;stroke-miterlimit:10;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 26,
    height: 41.47
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2.33,35a2.27,2.27,0,0,1,.09.65c0,.84-.43,1.52-1,1.52s-1-.68-1-1.52c0-.25.07-.59,0-.38m24.91.87a2.68,2.68,0,0,1,.09.65c0,.84-.43,1.52-1,1.52s-1-.68-1-1.52a2.17,2.17,0,0,1,.11-.69s0-.05,0-.07M13.48,38.79a2.29,2.29,0,0,1,.09.66c0,.84-.43,1.52-1,1.52s-1-.68-1-1.52a2.23,2.23,0,0,1,.11-.7.64.64,0,0,0,0-.07M21.33,18a.58.58,0,1,1-.58-.57A.58.58,0,0,1,21.33,18Zm-1.16-5a.58.58,0,1,1-.57-.57A.57.57,0,0,1,20.17,13Zm-4.29,8.23a25.59,25.59,0,0,1-1.57,9.92c-3.88,8.2-10,5.61-10-3.89a32.92,32.92,0,0,1,.77-8.31m11.53,2.28a25.36,25.36,0,0,1-1.74,10.53C10.5,40.59,3.58,37.54,3.58,27.27A38.77,38.77,0,0,1,5.12,15.48m9.61,1.9H17v3.81H14.73ZM8.24,1l2.93,10.5M10.1,2.6l7.23-.42L19.46,8.5l-7.66.84Zm-5,5.28,4.61,4.18a7.57,7.57,0,0,1,2.82,6c-.1,4.06-.15,5.07-.16,9.12,0,2.92,0,4,0,6.9m9.67.25a8.89,8.89,0,0,1,3.46.89V36H20.88l-6.54,1.14-.77,1.52H11.65l-.77-2.28m-1.53-.31-2.7-1.21m-1.15,0-5,.38V33.74l4.23-.38M20.5,10.54c1.48,1.53,2.88,4,2.69,6.08l-.39,16a2.82,2.82,0,0,1-2.69,2.66c-2.69.38-8.46.76-8.46.76m-.77-.38-5-1.91M5.12,32V7.88l3.26-.31M7.12,2.18S7.55.92,8.4.92,16.48.5,18.18.5l3.15,8.91a.7.7,0,0,1-.55.91l-9.4,1.12a1.73,1.73,0,0,1-2.13-1.26C8.82,8.5,7.12,2.18,7.12,2.18Z",
    transform: "translate(0 0)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSopranoSmallIcon);
export default __webpack_public_path__ + "static/media/sopranoSmallIcon.180e610c01daa579850eb3b19a17be43.svg";
export { ForwardRef as ReactComponent };